var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.iframes = new (function () {
    var self = this;

    this.init = function () {
        self.cookieConsent();
    };

    this.cookieConsent = function () {
        $(".cookieLink").each(function () {
            this.setAttribute("href", "javascript:Cookiebot.renew()");
        });
    };
})();
